















/* eslint-disable */
import Vue from "vue";
import ChatService from "@/services/chat.service";
import HomeService from '@/services/home.service';
export default Vue.extend({
    name: 'validChat',
    data() {
        return {
            claroOscuro:"",
            originBot:"",
            modal:true,
            urlRedirigir:"",
            dateInitBot:new Date(),
            keyChatInit:"",
            IsEnableLogPerformace: String(localStorage.getItem("IsEnableLogPerformace")) == "true",
        }
    },
    mounted(){
        console.log("Validando Chat");
        this.dateInitBot=new Date();
        this.cargaEstilos();
        //setTimeout(()=>{
        this.obtenerIP();
        //},50000);
    },
    methods: {
        obtenerIP: function(){         
            ChatService.obtenerIp().then(data => {
                console.log(data.data)
                const valores = window.location.search;
                const urlParams = new URLSearchParams(valores);
                if(urlParams.has('id')){
                    var id:any = atob(String(urlParams.get('id')));
                    var ClientBeginInfo = JSON.parse(id);
                    ClientBeginInfo.Ip=data.data;
                    this.cargaInicial(btoa(JSON.stringify(ClientBeginInfo)));
                }else{
                    this.$router.push("/Error");
                }
            }).catch(()=>{
                console.error("No se pudo obtener la IP");
                this.$router.push("/Error");
            });
        },
        cargaInicial: function (ClientBeginInfo:any) {
            ChatService.ValidChat(ClientBeginInfo).then( resp =>{
                let keyChat:string = resp.data.keyChat;
                localStorage.setItem("clientData-" + keyChat, resp.data.clientData);
                this.registerlogsPerformance(keyChat);
                setTimeout(()=>{this.$router.push(resp.data.urlRedirigir);},100);
            }).catch(error=>{
                console.error("ocurrio un error",error);
                this.$router.push("/Error");
            });
        },
        cargaEstilos(){
            HomeService.CargaInicial().then((resp) => {
                localStorage.setItem("claroOscuro", resp.data.claroOscuro);
                localStorage.setItem("originBot", resp.data.originBot);
                localStorage.setItem("pais", resp.data.pais);
                localStorage.setItem("urlRedirigir", resp.data.urlRedirigir);
                this.urlRedirigir = resp.data.urlRedirigir;
            }).catch((error) =>{
                console.error("Error al realizar la carga inicial validChat",error);
            });
        },
        registerlogsPerformance(keyChat:string) {
            debugger;
            console.log("ValidaChat : "+ this.IsEnableLogPerformace);
            if(this.IsEnableLogPerformace){
                let requestDerivacion: any = {
                    KeyChat: "",
                    IdConCopilot: "",
                    HoraInteraccionInicio: "",
                    HoraInteraccionFin: "",
                    DuracionEspera: 0,
                    Tipo: 1,
                    Traferencia: false,
            };
            requestDerivacion.KeyChat= keyChat;
            
            requestDerivacion.HoraInteraccionInicio=this.dateInitBot.toISOString().replace(/[TZ]/g, ' ');
            let fechaFin = new Date();
            requestDerivacion.HoraInteraccionFin=fechaFin.toISOString().replace(/[TZ]/g, ' ');
                ChatService.InsertLogsPerformance(requestDerivacion).then((resp) => {}).catch((error) => {
                    console.error(error);
                    });
            }
               
    },
    formatDate(date: any) {
      var vPart = date.split("/");
      var vPartTime = vPart[2].split(",");

      let intDate = {
        vFirst: parseInt(vPart[0]),
        vSecond: parseInt(vPart[1]),
      };
      let intDateandTime = {
        vFirst: parseInt(vPartTime[0]),
      };
      var gDate = intDate.vFirst > 31 ? intDateandTime.vFirst : intDate.vFirst;
      var gYear = intDate.vFirst > 31 ? intDate.vFirst : intDateandTime.vFirst;
      var month = "" + intDate.vSecond,
        day = "" + gDate,
        year = gYear;
      return [gYear, intDate.vSecond, gDate].join("-") + "" + vPartTime[1];
    },

    }

})
